<template>
    <div>
        <app-server />
        <app-create />
        <app-account />
    </div>
</template>

<script>
import create from '../components/account_create.vue'
import account from '../components/account.vue'
import server from '../components/server.vue'

export default {
    components: {
        appCreate: create,
        appAccount: account,
        appServer: server,
    },
}
</script>